import React from 'react';
import PropTypes from 'prop-types';


import {Number} from '../../../global';


function TrendMatchQuota({quota}) {

    return (
        <>
            <Number value={quota}/> %
        </>
    );
}


TrendMatchQuota.propTypes = {
    quota: PropTypes.number.isRequired
};

TrendMatchQuota.defaultProps = {};


export default TrendMatchQuota;
